module.exports = __webpack_public_path__ + "img/Umb30_uv_logotie_5460.0c595503.svg";